import React, { useState } from "react";
import "../../Styles/Press.css";
import {
  FaWhatsapp,
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaYoutube,
} from "react-icons/fa";
import ps1 from '../../essets/ps1.png';
import ps2 from '../../essets/ps2.png';
import ps3 from '../../essets/ps3.png';
import ps4 from '../../essets/ps4.png';
import ps5 from '../../essets/ps5.png';
import ps6 from '../../essets/ps6.png';
import ps7 from '../../essets/ps7.png';
import ps8 from '../../essets/ps8.png';

const Press = () => {
  const press = [
    {
      image: ps1,
      caption: "Press Event 1",
      date: "May 12, 2024",
      location: "Kandukur, Prakasam Dist.",
      description: "Press meet addressing local development works and public grievances.",
    },
    {
      image: ps2,
      caption: "Press Event 2",
      date: "May 05, 2024",
      location: "Ongole, Prakasam Dist.",
      description: "Media interaction on party campaign strategy and upcoming programs.",
    },
    {
      image: ps3,
      caption: "Press Event 3",
      date: "Apr 28, 2024",
      location: "Kandukur Town Hall",
      description: "Conference with local reporters covering constituency issues.",
    },
    {
      image: ps4,
      caption: "Press Event 4",
      date: "Apr 20, 2024",
      location: "UTF Office, Kandukur",
      description: "Press briefing with teachers' union on education sector reforms.",
    },
    {
      image: ps5,
      caption: "Press Event 5",
      date: "Apr 15, 2024",
      location: "Party Office, Kandukur",
      description: "Discussion with senior leaders on constituency development plans.",
    },
    {
      image: ps6,
      caption: "Press Event 6",
      date: "Apr 10, 2024",
      location: "Kandukur Rural Mandal",
      description: "Public interaction and press coverage during village visit.",
    },
    {
      image: ps7,
      caption: "Press Event 7",
      date: "Apr 03, 2024",
      location: "Kandukur Bus Stand Area",
      description: "Media briefing on infrastructure and road development works.",
    },
    {
      image: ps8,
      caption: "Press Event 8",
      date: "Mar 28, 2024",
      location: "Kandukur Constituency Office",
      description: "Joint press meet with local party representatives.",
    },
  ];

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 8;
  const totalPages = Math.ceil(press.length / itemsPerPage) || 1;

  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentItems = press.slice(startIndex, startIndex + itemsPerPage);

  const goToPage = (page) => {
    if (page < 1 || page > totalPages || page === currentPage) return;
    setCurrentPage(page);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const getPageNumbers = () => {
    const pages = [];
    const siblingCount = 1;

    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
      return pages;
    }

    const leftSibling = Math.max(currentPage - siblingCount, 1);
    const rightSibling = Math.min(currentPage + siblingCount, totalPages);

    const showLeftEllipsis = leftSibling > 2;
    const showRightEllipsis = rightSibling < totalPages - 1;

    pages.push(1);
    if (showLeftEllipsis) pages.push("ellipsis-left");

    for (let i = leftSibling; i <= rightSibling; i++) {
      if (i !== 1 && i !== totalPages) pages.push(i);
    }

    if (showRightEllipsis) pages.push("ellipsis-right");
    pages.push(totalPages);

    return pages;
  };

  return (
    <div className="press-section">
      <div className="press-heading-wrap">
        <h1 className="press-heading">PRESS</h1>
        <div className="press-heading-underline">
          <span></span>
          <span className="press-underline-icon">📅</span>
          <span></span>
        </div>
        <p className="press-subtitle">
          Stay updated with the latest press meets, conferences and media interactions.
        </p>
      </div>

      <div className="press-container">
        <div className="press-grid">
          {currentItems.map((item, index) => (
            <div className="press-flip-card" key={startIndex + index}>
              <div className="press-flip-inner">
                {/* FRONT */}
                <div className="press-flip-front">
                  <div className="press-image-wrap">
                    <img
                      src={item.image}
                      alt={item.caption}
                      className="press-image"
                    />
                    <span className="press-camera-badge">📷</span>
                  </div>
                  <div className="press-card-body">
                    <h4 className="press-caption">{item.caption}</h4>
                    <div className="press-date-row">
                      <span className="press-date-icon">📅</span>
                      <span className="press-date-text">{item.date}</span>
                    </div>
                    <button className="press-view-btn">
                      View Details <span className="press-arrow">›</span>
                    </button>
                  </div>
                </div>

                {/* BACK */}
                <div className="press-flip-back">
                  <h4 className="press-back-title">{item.caption}</h4>
                  <div className="press-back-row">
                    <span className="press-back-icon">📍</span>
                    <span className="press-back-text">{item.location}</span>
                  </div>
                  <div className="press-back-row">
                    <span className="press-back-icon">📅</span>
                    <span className="press-back-text">{item.date}</span>
                  </div>
                  <p className="press-back-desc">{item.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {press.length === 0 && (
          <p className="press-no-results">No press events found.</p>
        )}

        {totalPages > 1 && (
          <div className="press-pagination">
            <button
              className="press-page-btn press-page-nav"
              disabled={currentPage === 1}
              onClick={() => goToPage(currentPage - 1)}
              aria-label="Previous page"
            >
              ‹
            </button>

            {getPageNumbers().map((p, i) =>
              typeof p === "string" ? (
                <span className="press-page-ellipsis" key={`${p}-${i}`}>
                  ...
                </span>
              ) : (
                <button
                  key={p}
                  className={`press-page-btn ${
                    currentPage === p ? "active" : ""
                  }`}
                  onClick={() => goToPage(p)}
                  aria-current={currentPage === p ? "page" : undefined}
                >
                  {p}
                </button>
              )
            )}

            <button
              className="press-page-btn press-page-nav"
              disabled={currentPage === totalPages}
              onClick={() => goToPage(currentPage + 1)}
              aria-label="Next page"
            >
              ›
            </button>
          </div>
        )}
      </div>

      {/* FOOTER */}
      <footer className="press-footer">
        <div className="press-footer-left">
          <span className="press-footer-icon">📰</span>
          <span className="press-footer-text">
            © 2024 Inturi Nageswara Rao. All Rights Reserved.
          </span>
        </div>

        <div className="press-footer-right">
          <span className="press-footer-follow">Follow Us :</span>
          <div className="press-social-icons">
            <a href="https://wa.me/" target="_blank" rel="noreferrer" className="press-social-icon whatsapp" aria-label="WhatsApp">
              <FaWhatsapp />
            </a>
            <a href="https://facebook.com/" target="_blank" rel="noreferrer" className="press-social-icon facebook" aria-label="Facebook">
              <FaFacebookF />
            </a>
            <a href="https://twitter.com/" target="_blank" rel="noreferrer" className="press-social-icon twitter" aria-label="Twitter">
              <FaTwitter />
            </a>
            <a href="https://instagram.com/" target="_blank" rel="noreferrer" className="press-social-icon instagram" aria-label="Instagram">
              <FaInstagram />
            </a>
            <a href="https://youtube.com/" target="_blank" rel="noreferrer" className="press-social-icon youtube" aria-label="YouTube">
              <FaYoutube />
            </a>
          </div>
        </div>
      </footer>

      <div className="press-credit-bar">
        Designed and Developed by <span>YSK Infotech Pvt Ltd</span>
      </div>
    </div>
  );
};

export default Press;